import { render, staticRenderFns } from "./InsightsCard.vue?vue&type=template&id=cf8ec66e"
import script from "./InsightsCard.vue?vue&type=script&lang=js"
export * from "./InsightsCard.vue?vue&type=script&lang=js"
import style0 from "./InsightsCard.vue?vue&type=style&index=0&id=cf8ec66e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports